import { memo } from "react";
import ResizeObserver from "resize-observer-polyfill";
import { useAppConfiguration } from "./hooks/useAppConfiguration";
import { AppContent } from "./components/AppContent";

if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

const App = memo(() => {
  const { configData, params, isLoading, isDataLoading } =
    useAppConfiguration();

  return (
    <AppContent
      configData={configData}
      params={params}
      isLoading={isLoading}
      isDataLoading={isDataLoading}
    />
  );
});

export default App;
